import { render } from "./PlayerCap.vue?vue&type=template&id=5e867d6c"
import script from "./PlayerCap.vue?vue&type=script&lang=js"
export * from "./PlayerCap.vue?vue&type=script&lang=js"

import "./PlayerCap.vue?vue&type=style&index=0&id=5e867d6c&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__